// Marka simgeleri. Bağlantı anahtarı (Branch.links[].icon) ya kullanıcının seçtiği bir EMOJİ, ya da
// `brand:` önekli bir marka id'si — çünkü Unicode'da Instagram, WhatsApp, Gmail, TikTok logosu yok
// ve 📷 "Instagram" demiyor.
//
// Görseller bu uygulamanın kendi `public/brands/` klasöründen geliyor. Panelde de AYNI dosyalar var
// (panel/public/brands, seçici oradan besleniyor): panelde seçilen simge menüde bire bir görünmeli.
// Panelin dosyasına bağlanmak müşteriye açık menüyü yönetim paneline bağımlı yapardı.
//
// Yeni marka = iki klasöre aynı SVG + panelde lib/brandEmojis'e bir satır.
const BRAND_PREFIX = "brand:";

// Anahtar bir marka simgesi mi? Değilse emojidir ve olduğu gibi basılır. Emoji hiçbir zaman bu
// önekle başlamaz, o yüzden ayrım güvenli.
export const brandName = (icon) =>
  icon?.startsWith(BRAND_PREFIX) ? icon.slice(BRAND_PREFIX.length) : null;

export const brandUrl = (name) => `/brands/${name}.svg`;

// Kiracının kendi yüklediği simge mi? O zaman anahtar doğrudan R2 adresi (panel → api
// /tenant/link-icon). Hazır emoji ve marka setinin dışına çıkmak isteyen kiracı — kendi rozeti,
// bir pazaryeri logosu — bu yoldan giriyor.
export const isUploadedIcon = (icon) => /^https?:\/\//i.test(icon ?? "");

// Bağlantı kiracının kendi sitesine gidiyorsa BrandIcon'a bu anahtar veriliyor: statik bir küre
// yerine markanın kendi amblemi çiziliyor (bkz. helpers/branchLinks isTenantSite).
// `brand:website` ile karıştırılmasın — o, kullanıcının seçtiği jenerik küre.
export const TENANT_LOGO_KIND = "tenant-logo";
